import { select } from 'd3-selection';
import { _cloneTemplate } from './utils.mjs'; 

const body = select(document.body);
const wrapper = body.select('#wrapper');
const dialog = body.select('#dialog');


async function fetchHtml(url, containerType = 'div') {
  const rawData = await fetch(url);
  const txt = await rawData.text();
  const container = document.createElement(containerType);
  container.innerHTML = txt;
  return container;
}


async function launchModal(talk) {
  dialog.select('.speakers')
    .attr('data-speaker-count', talk.speakers.length)
    .selectAll('div.speaker')
    .data(talk.speakers)
    .enter()
    .append('div')
    .attr('class', 'speaker')
    .each(function(d) {
      const container = select(this);
      
      if (d.img && !d.img.placeholder) {
        container.append('img')
          .datum(d.img)
          .attr('src', d => d.src)
          .attr('srcset', d => d.srcset)
          .attr('alt', d => d.alt);
      }

      container.append('span').text(d.name);
      if (d.pow) {
        const span = container.append('span');
        if (d.link) {
          span.append('a')
            .attr('href', d.link)
            .text(d.pow);
        }
        else { span.text(d.pow); }
      }
    });
  
  dialog.select('h2').text(talk.title);

  const time = dialog.select('.time');
  const startTime = talk?.slot?.startTime;
  const endTime = talk?.slot?.endTime;

  if (startTime && endTime) {time.text(`${startTime} - ${endTime}`); }
  else { time.remove(); }

  const container = await fetchHtml(talk.abstract);
  dialog.select('.abstract-inner').node().innerHTML = container.innerHTML;
}


function initModal(talks) {
  const content = dialog.select('.content');
  const template = select('#abstract-dialog-template');
  const cloneTemplate = _cloneTemplate.bind(template);
  let launcher = null;

  dialog.select('button')
    .on('click', function(evt) {
      if (evt.detail !== 0) { launcher = null; }
      dialog.node().close();
    });

  body.on('modallaunch', function({ detail }) {
    const id = detail.id;
    const talk = talks.get(id);
    if (!talk || !talk.abstract) { return; }

    launcher = detail.launcher;
    dialog.node().showModal();
    const evt = new CustomEvent('openmodal', { detail: { talk }});
    dialog.node().dispatchEvent(evt);
  });

  dialog
    .on('openmodal', function({ detail }) {
      cloneTemplate(content);
      launchModal(detail.talk);
      wrapper.attr('inert', 'inert');
    })
    .on('close', function() {
      wrapper.attr('inert', null);
      content.text('');
      launcher?.node()?.focus();
      launcher = null;
    });
}


function createModalLaunchButton(container, id) {
  const span = container.append('span');

  span.append('button')
    .attr('class', 'info-button')
    .attr('aria-label', 'Read more about this talk')
    .each(function() {
      select(this)
        .append('i')
        .attr('class', 'fa-solid fa-circle-info');
    })
    .on('click', async function() {
      const launcher = select(this);
      const evt = new CustomEvent('modallaunch', { detail: { id, launcher }});
      body.node().dispatchEvent(evt);
    });
}


export { initModal, createModalLaunchButton };
